import React, { FunctionComponent, useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@material-ui/core";
import { useLocation } from "react-router-dom";

import api from "../api";

// @ts-ignore

// 3. internal component imports

// Component
const PublicCampaignPicker: FunctionComponent = () => {
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaigns, setCampaigns] = React.useState<any>([]);
  const [portalId, setPortalId] = useState("");
  const [domain, setDomain] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState("");
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const portalIdQueryParam = params.get("portalId");
    const domainQueryParam = params.get("domain");
    const companyNameQueryParam = params.get("companyName");
    if (portalIdQueryParam) {
      setPortalId(portalIdQueryParam);
    }
    if (domainQueryParam) {
      setDomain(domainQueryParam);
    }
    if (companyNameQueryParam) {
      setCompanyName(companyNameQueryParam);
    }
  }, [search]);

  const handleChange = (event: any) => {
    setSelectedCampaign(event.target.value as string);
  };

  const getHubspotCampaigns = async (portalIdArg: string) => {
    const resp = await api.getHubspotCampaigns(portalIdArg);
    // eslint-disable-next-line no-console
    console.log(resp.payload.campaigns);
    setCampaigns(resp.payload.campaigns);
    setIsLoading(false);
  };

  const isInactiveCampaignSelected = (selectedCampaign &&
    !campaigns.find((campaign: any) => campaign.brandgenCampaignPoolId === selectedCampaign)?.active) as boolean;

  const addCompanyToCampaign = async (campaignId: string) => {
    setIsLoading(true);
    const resp = await api.addCompanyToCampaign(portalId, campaignId, domain, companyName);
    setIsLoading(false);
    setIsComplete(true);
    // eslint-disable-next-line no-console
    console.log(resp);
    if (resp.payload.message === "no-match") {
      setError("No match found for this company in our Database. We couldn't add this company to the campaign.");
    } else if (resp.payload.message === "company-limit-reached") {
      setError(
        "The selected campaign has reached the maximum number of companies that can be added to it. We couldn't add this company to the campaign.",
      );
    }
  };

  useEffect(() => {
    if (portalId) getHubspotCampaigns(portalId);
  }, [portalId]);

  return (
    <>
      <Dialog
        open={isConfirmationDialogOpen}
        onClose={() => {
          setIsConfirmationDialogOpen(false);
        }}
      >
        <DialogContent>
          <Typography variant="h6">
            You are about to add this company to an inactive campaign. Are you sure you want to proceed?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setIsConfirmationDialogOpen(false);
            }}
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              addCompanyToCampaign(selectedCampaign);
              setIsConfirmationDialogOpen(false);
            }}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Row
        className="align-items-center"
        style={{
          height: "90vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <Col sm="12" md={{ offset: 2, size: 8 }} lg={{ offset: 3, size: 6 }} className="my-auto">
          <Paper className="p-4 w-75 mx-auto text-center" elevation={3}>
            {isComplete && (
              <>
                {error && (
                  <Typography variant="h5" className="mb-4">
                    {error}
                  </Typography>
                )}
                {!error && (
                  <Typography variant="h5" className="mb-4">
                    The campaign has been added to your HubSpot account. You can now close this window.
                  </Typography>
                )}
              </>
            )}

            {!isComplete && (
              <>
                {!isLoading && (
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Campaign</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedCampaign}
                      label="Age"
                      onChange={handleChange}
                    >
                      {campaigns.map((campaign: any) => {
                        return (
                          <MenuItem key={campaign.brandgenCampaignPoolId} value={campaign.brandgenCampaignPoolId}>
                            {campaign.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}

                {isInactiveCampaignSelected && !isLoading && (
                  <div
                    className=""
                    style={{
                      color: "red",
                      marginTop: "1rem",
                    }}
                  >
                    The selected campaign is inactive, please contact your account manager to reactivate it.
                  </div>
                )}

                {!isLoading && (
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={selectedCampaign === ""}
                    style={{
                      marginTop: "2rem",
                    }}
                    onClick={() => {
                      if (isInactiveCampaignSelected) {
                        setIsConfirmationDialogOpen(true);
                      } else {
                        addCompanyToCampaign(selectedCampaign);
                      }
                    }}
                  >
                    Submit
                  </Button>
                )}

                {isLoading && <CircularProgress />}
              </>
            )}
          </Paper>
        </Col>
      </Row>
    </>
  );
};

export default PublicCampaignPicker;
